/* Add custom attribute to image block, in Sidebar */
const { __ } = wp.i18n;

const { createHigherOrderComponent } = wp.compose;
const { Fragment, useEffect } = wp.element;
const { InspectorControls } = wp.blockEditor;
const { PanelBody, ToggleControl } = wp.components;

import classnames from "classnames";

// Enable custom attributes on Search block
const enableSetWhiteOnBlocks = ["core/search"];
/**
 * Declare our custom attributes
 * @param settings
 * @param name
 * REF: https://rudrastyh.com/gutenberg/change-default-blocks-with-block-filters.html
 */
const setSearchAttributes = (settings, name) => {
  // Do nothing if it's another block than our defined ones.
  if (!enableSetWhiteOnBlocks.includes(name)) {
    return settings;
  }
  const newSettings = Object.assign({}, settings, {
    attributes: Object.assign({}, settings.attributes, {
      isWhite: { type: "boolean" },
      hideOnMobile: { type: "boolean" },
    }),
  });

  return newSettings;
};
wp.hooks.addFilter(
  "blocks.registerBlockType",
  "ae-block/search-variation",
  setSearchAttributes,
);

/**
 * Add Custom Select to Image Sidebar
 */
const withSetAttributesToggle = createHigherOrderComponent((BlockEdit) => {
  return (props) => {
    // If current block is not allowed
    if (!enableSetWhiteOnBlocks.includes(props.name)) {
      return <BlockEdit {...props} />;
    }

    const { attributes, setAttributes } = props;
    const { isWhite, hideOnMobile } = attributes;

    useEffect(() => {
      if (hideOnMobile) {
        const searchIcon = document.querySelector(".wp-block-search__button");
        const searchBar = document.querySelector(".wp-block-search__input");

        const toggleSearchBar = () => {
          if (searchBar.style.display === "none" || !searchBar.style.display) {
            searchBar.style.display = "block";
            searchBar.classList.add("dropdown");
          } else {
            searchBar.style.display = "none";
            searchBar.classList.remove("dropdown");
          }
        };

        if (searchIcon) {
          searchIcon.addEventListener("click", toggleSearchBar);
        }

        return () => {
          if (searchIcon) {
            searchIcon.removeEventListener("click", toggleSearchBar);
          }
        };
      }
    }, [hideOnMobile]);

    return (
      <Fragment>
        <BlockEdit {...props} />
        <InspectorControls>
          <PanelBody title={__("Search Variation Attributes")}>
            <ToggleControl
              label={__("Set styles to white")}
              checked={isWhite}
              onChange={() => {
                setAttributes({
                  isWhite: !isWhite,
                });
              }}
            />
            <ToggleControl
              label={__("Hide on mobile")}
              checked={hideOnMobile}
              onChange={() => {
                setAttributes({
                  hideOnMobile: !hideOnMobile,
                });
              }}
            />
          </PanelBody>
        </InspectorControls>
      </Fragment>
    );
  };
}, "withSetAttributesToggle");

wp.hooks.addFilter(
  "editor.BlockEdit",
  "ae-block/search-variation",
  withSetAttributesToggle,
);

/**
 * Add custom class to block in Edit
 */
const withSetAttributesProp = createHigherOrderComponent((BlockListBlock) => {
  return (props) => {
    // If current block is not allowed
    if (!enableSetWhiteOnBlocks.includes(props.name)) {
      return <BlockListBlock {...props} />;
    }

    const { attributes } = props;
    const { isWhite, hideOnMobile } = attributes;

    let className = "";
    if (isWhite) {
      className += " white";
    }

    if (hideOnMobile) {
      className += " hide-on-mobile";
    }

    return <BlockListBlock {...props} className={className} />;
  };
}, "withSetAttributesProp");

wp.hooks.addFilter(
  "editor.BlockListBlock",
  "ae-block/search-variation",
  withSetAttributesProp,
);

/**
 * Save our custom attributes
 * @param extraProps
 * @param blockType
 * @param attributes
 */
const saveSearchAttributes = (extraProps, blockType, attributes) => {
  if (blockType.name !== "core/search") {
    return extraProps;
  }

  const { isWhite, hideOnMobile } = attributes;

  let className = extraProps.className || "";
  if (isWhite) {
    className += " white";
  }
  if (hideOnMobile) {
    className += " hide-on-mobile";
    extraProps = Object.assign({}, extraProps, {
      "data-hide-on-mobile": true,
    });
  }
  extraProps.className = classnames(extraProps.className, className);

  return extraProps;
};
wp.hooks.addFilter(
  "blocks.getSaveContent.extraProps",
  "ae-block/search-variation",
  saveSearchAttributes,
);
